import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { TenantBrandingProvider } from "./contexts/TenantBrandingContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import DMEProjectPage from "./pages/DMEProjectPage";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Tenants from "./pages/Tenants";
import TenantDetail from "./pages/TenantDetail";
import SEODashboard from "./pages/SEODashboard";
import Invoices from "./pages/Invoices";
import Billing from "./pages/Billing";
import BillingDetail from "./pages/BillingDetail";
import Users from "./pages/Users";
import Profile from "./pages/Profile";
import TenantSettings from "./pages/TenantSettings";
import Meetings from "./pages/Meetings";
import CalendarPage from "./pages/CalendarPage";
import Forms from "./pages/Forms";
import AndGoPage from "./pages/AndGoPage";

// Settings Pages
import SettingsSystem from "./pages/settings/SettingsSystem";
import SettingsOrganization from "./pages/settings/SettingsOrganization";
import SettingsNotifications from "./pages/settings/SettingsNotifications";
import SettingsProductsServices from "./pages/settings/SettingsProductsServices";
import SettingsStorage from "./pages/settings/SettingsStorage";
import FormTemplatesIndex from "./pages/settings/FormTemplatesIndex";
import FormTemplatesWeb from "./pages/settings/FormTemplatesWeb";
import FormTemplatesConstruction from "./pages/settings/FormTemplatesConstruction";

// Layouts
import DashboardLayout from "./components/Layout/DashboardLayout";
import SettingsLayout from "./components/Layout/SettingsLayout";
import TenantPortal from "./components/TenantPortal";

function App() {
  return (
    <ThemeProvider>
      <TenantBrandingProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* White-label tenant portal — e.g. myclientpm.com/nmnetwork */}
            <Route path="/:slug" element={<TenantPortal />} />
            
            {/* Dashboard routes */}
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/dme/:projectId" element={<DMEProjectPage />} />
              <Route path="/projects/:projectId" element={<ProjectDetail />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:clientId" element={<ClientDetail />} />
              <Route path="/tenants" element={<Tenants />} />
              <Route path="/tenants/:tenantId" element={<TenantDetail />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/meetings" element={<Meetings />} />
              <Route path="/seo" element={<SEODashboard />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/billing/:tenantId" element={<BillingDetail />} />
              <Route path="/users" element={<Users />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/my-settings" element={<TenantSettings />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/and-go" element={<AndGoPage />} />
              
              {/* Settings routes with dedicated sidebar */}
              <Route path="/settings" element={<SettingsLayout />}>
                <Route index element={<SettingsSystem />} />
                <Route path="organization" element={<SettingsOrganization />} />
                <Route path="products-services" element={<SettingsProductsServices />} />
                <Route path="storage" element={<SettingsStorage />} />
                <Route path="templates" element={<FormTemplatesIndex />} />
                <Route path="templates/web" element={<FormTemplatesWeb />} />
                <Route path="templates/construction" element={<FormTemplatesConstruction />} />
                <Route path="notifications" element={<SettingsNotifications />} />
              </Route>
            </Route>

            {/* Redirects */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </TenantBrandingProvider>
    </ThemeProvider>
  );
}

export default App;
